import type { Direction } from "../core/types";

export interface PlanarPosition {
  readonly x: number;
  readonly z: number;
}

const CENTER_CARDINAL_LIMIT = 2.68;
const CENTER_DIAGONAL_LIMIT = 3.46;
const CORRIDOR_HALF_WIDTH = 0.68;
const CORRIDOR_START = 2.45;
const CORRIDOR_END = 9.8;

export function resolveMazeMovement(
  current: PlanarPosition,
  displacement: PlanarPosition,
  openedDirection: Direction | null,
): PlanarPosition {
  const full = { x: current.x + displacement.x, z: current.z + displacement.z };
  if (isWalkable(full, openedDirection)) return full;

  let resolved = current;
  const xOnly = { x: current.x + displacement.x, z: current.z };
  if (isWalkable(xOnly, openedDirection)) resolved = xOnly;
  const zOnly = { x: resolved.x, z: resolved.z + displacement.z };
  if (isWalkable(zOnly, openedDirection)) resolved = zOnly;
  return resolved;
}

export function isWalkable(position: PlanarPosition, openedDirection: Direction | null): boolean {
  const absoluteX = Math.abs(position.x);
  const absoluteZ = Math.abs(position.z);
  const insideCenter = absoluteX <= CENTER_CARDINAL_LIMIT
    && absoluteZ <= CENTER_CARDINAL_LIMIT
    && absoluteX + absoluteZ <= CENTER_DIAGONAL_LIMIT;
  if (insideCenter) return true;
  if (!openedDirection) return false;

  if (openedDirection === "north") {
    return absoluteX <= CORRIDOR_HALF_WIDTH && position.z >= CORRIDOR_START && position.z <= CORRIDOR_END;
  }
  if (openedDirection === "south") {
    return absoluteX <= CORRIDOR_HALF_WIDTH && position.z <= -CORRIDOR_START && position.z >= -CORRIDOR_END;
  }
  if (openedDirection === "east") {
    return absoluteZ <= CORRIDOR_HALF_WIDTH && position.x >= CORRIDOR_START && position.x <= CORRIDOR_END;
  }
  return absoluteZ <= CORRIDOR_HALF_WIDTH && position.x <= -CORRIDOR_START && position.x >= -CORRIDOR_END;
}
